import { useDeviationAttributes } from '../../../DeviationViews/hooks/useDeviationAttributes';
import { useSelector } from 'react-redux';
import { getIsCurrentUserAuthorOf } from '../../../redux/deviations/selectors';
export function useIsAddToGroupInMoreMenu(deviation) {
    const isOwner = useSelector((state)=>getIsCurrentUserAuthorOf(state, deviation));
    const { isGroupSubmittable  } = useDeviationAttributes(deviation, isOwner);
    // Put "add to group" under menu when:
    // a) the deviation is an adoptable, due to lack of space
    // b) we're not the owner of the deviation (T59403)
    return isGroupSubmittable && (deviation.isAdoptable || !isOwner);
}
